import moment from "moment";
import { TFunction } from "i18n";
import { checkIsYp } from "shared-auth";
import { DatesFormat } from "shared-types";
import { getPlayingAgeTitle } from "shared-utils";
import { UserRoleManager } from "core";
import { IBasicInfoViewModel } from "shared/modules/BasicInfo/models/sectionViewModels";
import { ConverterBasicInfo } from "./types";

export function mapCommonFields(
  basicInfo: ConverterBasicInfo,
  t: TFunction
): Partial<IBasicInfoViewModel> {
  const from = getPlayingAgeTitle(t, basicInfo.playingAgeFrom);
  const to = getPlayingAgeTitle(t, basicInfo.playingAgeTo);

  return {
    ...(basicInfo.age && basicInfo.isVisibleActualAge
      ? { actualAge: basicInfo.age }
      : {}),
    ...(checkIsYp(UserRoleManager.getUserType())
      ? {
          licenseRequired: basicInfo.isLicenseRequired
            ? t("common:label.yes")
            : t("common:label.no"),
        }
      : {}),
    hasTwin: basicInfo.hasTwin ? t("common:label.yes") : undefined,
    makeUp: basicInfo.makeUp,
    pregnancy: basicInfo.pregnantUntil
      ? moment(basicInfo.pregnantUntil).format(DatesFormat.dateFormatPrimary)
      : undefined,
    playingAge: t("performer:profile.basicInfo.playingAgeValue", { from, to }),
  };
}
